import { render } from "./IconHamburgerOpen.vue?vue&type=template&id=1e9e3095"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__